module.exports = __webpack_public_path__ + "img/DocAnchors.fe7af350.png";